// Theme Configuration
export const theme = {
  colors: {
    // Primary Colors
    primary: "#C90000",
    primaryDark: "#860000",
    primaryLight: "#ED9E9E",

    // Text Colors
    heading: "#292929",
    paragraph: "#292929",

    // Background Colors
    background: "#ECECEC",

    // Border & Grays
    border: "#DBDBDB",
    gray: "#B0B0B0",
    darkGray: "#585858",

    // Base Colors
    black: "#000000",
    white: "#292929",
    charcoal: "#403D40",
    burgundy: "#59110D",
  },

  breakpoints: {
    mobile: "480px",
    tablet: "768px",
    desktop: "1024px",
    wide: "1200px",
  },

  spacing: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
    xxl: "3rem",
  },

  fontSize: {
    xs: "0.75rem",
    sm: "0.875rem",
    base: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    xxl: "1.5rem",
    xxxl: "2rem",
    huge: "3rem",
  },

  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },

  transitions: {
    fast: "0.2s ease",
    normal: "0.3s ease",
    slow: "0.5s ease",
  },
};

export default theme;
